/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Personsoperativ1Inputs */

const de__field_personsoperativ1 = /** @type {(inputs: _Field_Personsoperativ1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Person Operativ`)
};

/**

* @param {_Field_Personsoperativ1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_personsoperativ1 = /** @type {((inputs?: _Field_Personsoperativ1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Personsoperativ1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_personsoperativ1(inputs)
});
export { _field_personsoperativ1 as "_field_personsOperativ" }